import type ReportingUiScopeMathsFluencySprintsStudentTableRoute from 'teacher-ui-client/reporting/ui-scope/maths/fluency-sprints/student/table/route'
import type ReportingUiScopeMathsFluencySprintsStudentTableController from 'teacher-ui-client/reporting/ui-scope/maths/fluency-sprints/student/table/controller'
import RouteTemplate from 'ember-route-template'
import { eq, notEq } from 'ember-truth-helpers'
import { FluencySprintsStudentOverview } from 'teacher-ui-client/components/tables/fluency-sprints/student-overview'
import Component from '@glimmer/component'

interface Signature {
  Args: {
    model: ModelFor<ReportingUiScopeMathsFluencySprintsStudentTableRoute>
    controller: ReportingUiScopeMathsFluencySprintsStudentTableController
  }
}

export class ReportingUiScopeMathsFluencySprintsStudentTablePage extends Component<Signature> {
  get mentalMinuteStudent() {
    const { mentalMinuteStudent } = this.args.model
    if (!mentalMinuteStudent) return null

    const lessons = mentalMinuteStudent.students[0].lessons
    const category = this.args.controller.category
    const aggregate = mentalMinuteStudent.aggregate[category]
    if (lessons.length === 0) return null

    return { lessons, aggregate }
  }

  <template>
    <div
      class="h-3
        {{if (eq @controller.category 'addition') 'bg-oceany-blue-100'}}
        {{if (eq @controller.category 'subtraction') 'bg-juicy-orange-100'}}
        {{if (eq @controller.category 'division') 'bg-purply-pink-100'}}
        {{if (eq @controller.category 'multiplication') 'bg-ms-green-100'}}"
    ></div>
    <FluencySprintsStudentOverview
      @data={{this.mentalMinuteStudent}}
      @onSortClick={{@controller.updateSorts}}
      @category={{if (notEq @controller.category "all") @controller.category}}
      @sortingConfig={{@controller.sortingConfig}}
      @exportable={{true}}
    />
  </template>
}

export default RouteTemplate(ReportingUiScopeMathsFluencySprintsStudentTablePage)
